import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { BsApiEndPoints } from '@app/core/services/bs-api/endpoints';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { ISearchFilter } from '@app/core/services/search/resource-search/search-query-types.service';
import { SearchQueryService } from '@app/core/services/search/resource-search/search-query.service';
import { StringUtilities } from '@app/core/utilities/string-utilities';
import { FileSearchColumnFields } from '../gridOptions/file-search-grid-options-formatter';
import { ISearchDataSourceOptions, SearchDataSource } from './search.datasource';
import { IServerSideGetRowsRequest } from 'ag-grid-community';

export class AppResultFileSearchDataSource extends SearchDataSource {
    constructor(
        searchQueryService: SearchQueryService,
        resourceDictionaryService: SearchResourceDictionaryService,
        dataSourceOptions: ISearchDataSourceOptions
    ) {
        const appResourceDictionary = resourceDictionaryService.getResourceConfigByType(SearchResourceType.AppResultFile);
        super(searchQueryService, appResourceDictionary, dataSourceOptions);
        this.origin = StringUtilities.trimTrailingSlash(BsApiEndPoints.V1PRE3_URL);

        const filterMethods: {[field: string]: (field: string, filterObj: any) => ISearchFilter} = {
            Project: (field, filterObj) => {
                return {
                    facets: ['Projects.Id'],
                    currentChoice: {
                        value: filterObj.value,
                        label: null,
                    }
                }
            },
            FileType: (field, filterObj) => {
                return {
                    facets: ['fileextension'],
                    currentChoice: {
                        value: filterObj.value,
                        label: null,
                    }
                }
            }
        };

        this.filterMethods = filterMethods as any;
    }


    get rawTextFilterColumnName(): string {
        return FileSearchColumnFields.Name;
    }

    getRowsRequest(params: any, rowsRequest: IServerSideGetRowsRequest, response: any) {
        // hack to get v1pre responses working with v2 counts for search result totals
        this.response = { Paging: { TotalCount: response.Response.TotalCount } } as any;

        return {
            ...rowsRequest,
            rowData: response.Response.Items,
            startRow: response.Response.Offset,
            lastRow: this.pagination ? response.Response.TotalCount : response.Response.Items.length
        };
    }

}
